import moment from 'moment';
// import { tryElectronPrint } from './printElectron';

const defineCss = () => `
  body {
    font-family: Arial, sans-serif;
    margin: 20px;
    font-size: 12px;
  }
  .header {
    text-align: center;
    margin-bottom: 20px;
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
  }
  .company-name {
    font-size: 18px;
    font-weight: bold;
    color: #2c5aa0;
  }
  .report-title {
    font-size: 16px;
    font-weight: bold;
    margin: 5px 0;
  }

  .date-info {
    font-size: 14px;
    margin: 5px 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
    font-size: 11px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
    font-size: 11px;
  }

  th, td {
    border: 1px solid #000;
    padding: 4px 6px;
    text-align: left;
  }
  th {
    background-color: #f0f0f0;
    font-weight: bold;
    text-align: center;
  }

  .category-section {
    margin: 15px 0;
    page-break-inside: avoid;
  }

  .category-title {
    font-weight: bold;
    background-color: #e6f3ff;
    padding: 5px;
    margin: 5px 0;
    border: 1px solid #000;
  }

  .summary-section {
    margin-top: 20px;
    border-top: 2px solid #000;
    padding-top: 10px;
  }

  .total-row {
    font-weight: bold;
    background-color: #f5f5f5;
  }
  .text-center { text-align: center; }

  .text-right { text-align: right; }

  @media print {
    body { margin: 0; }
    .no-print { display: none; }
  }

  @page {
    margin: 12mm 10mm;
    size: A4;
  }
`;

const generatePrintableContent = (orders, reportTitle) => {

  const printingTime = moment().format('hh:mm A');
  const firstDate = orders.length > 0 && orders[0].createdAt ? moment(orders[0].createdAt) : moment();
  const collectionDate = firstDate.format('DD-MMMM-YYYY');
  const daysInMonth = firstDate.daysInMonth();

  const bodyRows = orders.map((order, idx) => {
    return `
      <tr>
        <td class="text-center">৳ ${order.realPaidAmount || 0}</td>
        <td class="text-center">৳ ${order.realDueAmount || 0}</td>
        <td class="text-center">৳ ${order.realDiscountAmount || 0}</td>
        <td class="text-center"><strong>৳ ${order.realTotalAmount || 0}</strong></td>
      </tr>`;
  }).join('');

  return `
    <div class="header">
      <div class="company-name">MEDIPLUS MEDICAL SERVICES (Pvt) LTD.</div>
      <div class="report-title">${reportTitle || 'Daily Collection Short'}</div>
      <div class="date-info">Collection Date: ${collectionDate} <br/> Printing Time: ${printingTime}</div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Advance</th>
          <th>Due</th>
          <th>Less</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        ${bodyRows}
        <tr class="total-row">
          <td class="text-center"><strong>৳ ${orders.reduce((acc, order) => acc + (order.realPaidAmount || 0), 0)}</strong></td>
          <td class="text-center"><strong>৳ ${orders.reduce((acc, order) => acc + (order.realDueAmount || 0), 0)}</strong></td>
          <td class="text-center"><strong>৳ ${orders.reduce((acc, order) => acc + (order.realDiscountAmount || 0), 0)}</strong></td>
          <td class="text-center"><strong>৳ ${orders.reduce((acc, order) => acc + (order.realTotalAmount || 0), 0)}</strong></td>
        </tr>
      </tbody>
    </table>

    <div class="summary-section">
      <h3>Summary</h3>
      <p><strong>Total Orders:</strong> ${orders.length}</p>
      <p><strong>Total Collection:</strong> ৳${orders.reduce((acc, order) => acc + (order.realTotalAmount || 0), 0)}</p>
    </div>

    <div style="margin-top:40px;text-align:right;">
      <div style="display:inline-block;width:220px;border-top:1px dotted #000;padding-top:6px;">Signature</div>
    </div>
`;
};

const printDailyCollectionShort = (orders, reportTitle) => {
  // 1. Create a hidden iframe to execute print securely
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const printWindow = iframe.contentWindow;
  if (!printWindow) {
    console.error('[printDailyCollectionShort] Hidden iframe context is unavailable.');
    alert('Failed to initialize print process. Please try again.');
    document.body.removeChild(iframe);
    return;
  }

  const rows = Array.isArray(orders) ? orders : [];
  if (!rows || rows.length === 0) {
    console.warn('No orders provided to print');
    return;
  }
  const firstDate = rows.length > 0 && rows[0].createdAt ? moment(rows[0].createdAt) : moment();
  const collectionMonth = firstDate.format('MMMM YYYY');
  const printTitle = `${reportTitle || 'Daily Collection Short'} - ${collectionMonth}`;
  const printContent = generatePrintableContent(rows, reportTitle) || '<div style="padding:20px;">No data to print</div>';
  const fullHtml = `
    <html>
      <head>
        <title>${printTitle}</title>
        <style>
          ${defineCss()}
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `;

  // 2. Safely output the HTML markup to the iframe window context
  printWindow.document.write(fullHtml);
  printWindow.document.close();

  // 3. Focus, print, call back, and safely garbage-collect the temporary iframe
  setTimeout(() => {
    // const didElectronPrint = tryElectronPrint(printWindow);
    // if (!didElectronPrint) {
    printWindow.focus();
    printWindow.print();
    printWindow.onafterprint = () => {
      printWindow.close();
    };
    // }
    document.body.removeChild(iframe);
  }, 500);
};

export default printDailyCollectionShort;
